module.exports = __webpack_public_path__ + "img/cayman-islands.5dcda5ca.svg";